import React from "react";
import { Col, Modal, Row } from "react-bootstrap";

const ThirukuralPopup = (props) => {
  const field = (fieldName) => props?.data?.[fieldName] || "";

  const inputField = (text, value) => {
    return (
      <Row className="mb-2">
        <Col md={12}>
          <label className="fw-bold">{text}</label>
        </Col>
        <Col md={12}>
          <div>
            <pre>{value} </pre>
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <>
      <Modal size="lg" {...props}>
        <Modal.Header closeButton>{`${props.title || "Thirukural"} - ${field(
          "kural_no"
        )}`}</Modal.Header>
        <Modal.Body>
          {/*<div className="p-2 bg-light mb-2 fw-bold">Tamil</div>*/}
          <Row className="mb-2">
            <Col md={6}>
              <label className="fw-bold">{"இயல்"}</label>
              <div>{field("iyal_tamil")}</div>
            </Col>
            <Col md={6}>
              <label className="fw-bold">{"அதிகாரம்"}</label>
              <div>{field("adikaram_tamil")}</div>
            </Col>
          </Row>
          <div
            className="bg-light p-3 pb-0 my-3"
            style={{ borderLeft: "5px solid blue" }}
          >
            {inputField("குறள்", field("kural_tamil"))}
          </div>
          <Row className="mb-2">
            <Col md={12}>
              <label className="fw-bold">{"பரிமேலழகர் உரை"}</label>
            </Col>
            <Col md={12}>
              <div>{field("parimelalagar_urai")}</div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col md={12}>
              <label className="fw-bold">{"மு.வரதராசனார் உரை"}</label>
            </Col>
            <Col md={12}>
              <div>{field("mu_varathar_urai")}</div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ThirukuralPopup;
